// @ts-nocheck
import React, { useState, useEffect, useMemo, useContext, useCallback } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import PS from '@/services/permission/permission-service';
import Breadcrumbs from '@/components/breadcrumbs';
import Storage from '@/utils/storage';
import { Box, Card, Flex, Tabs, Tooltip } from "@mantine/core";
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import constants from '@/utils/constants';
import tabStyles from '@/styles/Tabs.module.css';
import { useQuery } from "@tanstack/react-query";
import featureService from '@/services/feature/feature-service';
import StockTakeList from "@/PageComponents/Table/Component Tables/StockTakeList";
import StockTakeTemplateList from "@/PageComponents/Table/Component Tables/StockTakeTemplateList";
import ComingSoonText from "@/PageComponents/Premium/ComingSoonText";
import { createFileRoute } from '@tanstack/react-router'

function StocktakeList() {

    /** fieldSettings Start */
    /** fieldSettings End */

    const [viewStockTransactionsPermission] = useState(PS.hasPermission(Enums.PermissionName.StockTransactionsView));

    const messageBarContext = useContext(SCMessageBarContext);

    const router = useRouter()

    const [hasStockControl, setHasStockControl] = useState<boolean | undefined>();
    const {data: hasStockTake} = useQuery(['hasStockTake'], () => featureService.getFeature(constants.features.STOCK_TAKE))

    const [activeTab, setActiveTab] = useState<string | null>(null);

    const setInitialTab = (tabDataLocal = tabData) => {
        const tab = router.query.tab as string // TODO(tanstack-router): verify router.query → useParams/useSearch
        if (tab && tabDataLocal[tab] && tabDataLocal[tab].access !== false) {
            setActiveTab(tab)
        }
        else {
            setActiveTab(Object.entries(tabDataLocal).find(([, x]: any) => (x as any).access)?.[0] || 'stocktake');
        }
    };

    const tabData = useMemo(() => {
        let tabs: any = {};

        if (!!hasStockTake) {
            tabs.stocktake = {
                label: 'Stock Takes',
                new: true,
                access: !!hasStockTake,
                // access: PS.hasPermission(Enums.PermissionName.StockTake)
            };
            tabs.templates = {
                label: 'Item Templates',
                new: true,
                access: !!hasStockTake,
                // access: PS.hasPermission(Enums.PermissionName.StockTake)
            };
            tabs.schedules = {
                label: 'Schedules',
                new: true,
                access: false,
                // access: PS.hasPermission(Enums.PermissionName.StockTake)
            };
        }

        setInitialTab(tabs);

        return tabs;
    }, [hasStockControl, hasStockTake])

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
        featureService.getFeature(constants.features.STOCK_CONTROL).then((feature: any) => {
            setHasStockControl(!!feature);
        });
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    const handleTabChange = (newTabName: string | null) => {
        setActiveTab(newTabName)
        router.replace(router.asPath.split('?')[0] + '?tab=' + newTabName)
    }

    const tabs = <>
        <Tabs value={activeTab} onChange={handleTabChange}
            classNames={{
                tab: tabStyles.scTab,
                list: tabStyles.scTabList,
                tabLabel: tabStyles.scTabLabel
            }}
        >
            <Tabs.List mb={0} pb={0}>
                {
                    Object.entries(tabData).filter(([, x]: any) => true).map(
                        ([tabName, d]: any) => d &&
                            <Tooltip label={d.disabledLabel || ''}
                                key={tabName + 'tab'}
                                position={'bottom'}
                                disabled={!d.disabled || !d.disabledLabel}
                                color={'scBlue'}
                                openDelay={1000}
                                events={{ hover: true, focus: true, touch: true }}
                            >
                                <Tabs.Tab value={tabName}
                                    disabled={!d.access || d.disabled}
                                    color={(tabName === 'templates' ||  tabName === 'stocktake') ? 'yellow' : 'scBlue'}
                                >
                                    <Flex align={'center'} gap={5}>
                                        {d.label} {/*((tabName === 'templates' ||  tabName === 'stocktake')) && <BetaText />*/} {((tabName === 'schedules')) && <ComingSoonText />}
                                    </Flex>
                                </Tabs.Tab>
                            </Tooltip>
                    )
                }
                {/*<Tabs.Tab
                    styles={{}}
                    leftSection={<IconExternalLink size={15} />}
                    value={'stock-take'}
                    color={'scBlue'}
                >
                    <Flex align={'center'} gap={5}>
                        Stock Take
                    </Flex>
                </Tabs.Tab>*/}
            </Tabs.List>
        </Tabs>
    </>

    return (
        <>
            <Box
                mt={'var(--mantine-spacing-sm)'}
                px={'var(--mantine-spacing-md)'}
                mb={0}
                pb={0}
                style={(theme: any) => ({ borderBottom: `${theme.colors.gray[2]} 2px solid` })}
            >
                <Box my={'var(--mantine-spacing-md)'}>
                    <Breadcrumbs currPage={{
                        text: tabData[activeTab || '']?.label,
                        link: `/stock-take/list?tab=${activeTab || ''}`,
                        type: 'list'
                    }} />
                </Box>
                {tabs}
            </Box>

            {
            }
            <Box
                // ${activeTab === 'stocktake' ? ' - 85px' : ''}
                h={`calc(100vh - 135px${((messageBarContext as any)?.isActive ? ` - ${constants.messageBarMargin}px` : "")})`}
                style={(theme: any) => ({
                    backgroundColor: theme.colors.gray[1]
                })}
                p={'var(--mantine-spacing-xs)'}
            >
                <Card
                    style={{
                        backgroundColor: 'white'
                    }}
                    p={'var(--mantine-spacing-md)'}
                    radius={'md'}
                >
                    {
                        activeTab === 'stocktake' &&
                        <StockTakeList /> ||
                        activeTab === 'templates' &&
                        <StockTakeTemplateList /> ||
                        activeTab === 'schedules' &&
                        <StockTakeList />
                    }
                </Card>

            </Box>

        </>
    )
}
export default StocktakeList;

export const Route = createFileRoute('/_authenticated/stock-take/list')({ component: StocktakeList })
